import { render, staticRenderFns } from "./RsInspection.vue?vue&type=template&id=687c6550&scoped=true&"
import script from "./RsInspection.vue?vue&type=script&lang=js&"
export * from "./RsInspection.vue?vue&type=script&lang=js&"
import style0 from "./RsInspection.vue?vue&type=style&index=0&id=687c6550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c6550",
  null
  
)

export default component.exports